module.exports = __webpack_public_path__ + "static/media/TCS_F1.60f5be8f.txt";